import { client } from 'util/sdk';

// eslint-disable-next-line import/prefer-default-export
export const load = () =>
  client.eBillernets.query((_) => [_.limit(100), _.offset(0)]);
